// sol/SolApp.js
import React from "react";

import Design from "./Design";

export default function EthApp() {
  return (
   
      <div>
       
        <Design />
       
      </div>
    
  );
}
